import {Exception} from "sass";

export class TokenStorage {
    static myToken = ''
    static myRole = ''

    static saveToken(token){
        this.myToken = token;
    }

    static saveRole(role){
        this.myRole = role
    }

    static getRole(){
        return this.myRole
    }

    static isAdmin(){
        return this.myRole === 'ROLE_ADMIN'
    }

    static getToken(){
        if(this.myToken){
            return this.myToken
        }else{
            throw new Exception('Not authorized')
        }
    }

    static isAuthorized(){
        if(this.myToken){
            return true
        }else{
            return false
        }
    }

    static deleteToken(){
        this.myToken = ''
    }
}